import { APICall } from '../service';
const ControllerName = "page"

export const GetAuthorizedPages = () => {
    return APICall("get", ControllerName + "/relatedLookup")
}

export const GetPagesLookup = (lang) => {
    return APICall("get", ControllerName + "/lookup",{},lang)
}